import r from"./_baseIsTypedArray.js";import o from"./_baseUnary.js";import"./_nodeUtil.js";import{_ as s}from"../../_virtual/_nodeUtil.js";var a=r,t=o,e=s.exports,i=e&&e.isTypedArray,p=i?t(i):a;export{p as default};
//# sourceMappingURL=isTypedArray.js.map
